import React from 'react';
import { useState, useEffect } from "react";
import { useCarrito } from "./component/Cart";
import { Link } from 'react-router-dom';
import './styles/Pago.css';
import Swal from 'sweetalert2';

let baseUrl;
if(process.env.NODE_ENV === 'development') baseUrl = 'http://localhost:8080';
else baseUrl='https://app-formacion.vercel.app';

const Pago = () => {
    const { carrito, clearCarrito, cantidadTotal } = useCarrito();

    const [usuario, setUsuario] = useState(() => {
            const usuarioAlmacenado = localStorage.getItem("userLogueado");
            return usuarioAlmacenado ? JSON.parse(usuarioAlmacenado) : null;
    });

    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if(!usuario){
            window.location.href = '/login';
            return;  
        }
        if(carrito.length === 0){
             window.location.href = '/';
            return;
        }
    }, [usuario, carrito]);

    const manejarFinalizarCompra = async () => {
        setLoading(true);
        setError(null);

        try{
            const lineaItems = carrito.map(p => ({
                _id: p._id,
                Nombre: p.Nombre,
                Precio: p.Precio,
            }));
            
            //Crea sesión de stripe
            const sessionResp = await fetch(`${baseUrl}/api/pago/crear-checkout`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    usuarioId: usuario._id,
                    productos: lineaItems,
                    moneda: 'eur',  
                }),
            });
            
            if (!sessionResp.ok) {
                throw new Error('No se pudo crear la sesión de Stripe.');
            }

            const { url } = await sessionResp.json();

            window.location.href = url;
        } catch (error){
            console.error(error);
            setError(error.message);
            setLoading(false);
        }
    };

    return(
        <div className='principalPago'>
            <div className='ContenedorPago'>
                <div className='CardPago'>
                    <h2>Confirmar compra</h2>

                    {error && <p className='pagoError'>{error}</p>}

                    <ul className='pagoLista'>
                        {carrito.map(p => (
                            <li key={p._id} className='pagoItem'>
                                <span className='itemNombre'>{p.Nombre}</span>
                                <span className='itemDetalles'> {p.Precio.toFixed(2)} € </span>
                            </li>
                        ))}
                    </ul>
                    
                    <div className='pagoTotal'>
                        <span>Total: </span>
                        <span className='cantidadTotal'>
                            {cantidadTotal.toFixed(2)} €
                        </span>
                    </div>
                    

                    <button className="botonPago" onClick={manejarFinalizarCompra} disabled={loading || error}>
                        {loading ? 'Procesando...' : 'Pagar'}
                    </button>

                    <div className='pagoCancelar'>
                        <Link to="/" className="Cancelarlink">
                            Cancelar compra
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Pago;